"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GOOGLE_MAPS_API_KEY = void 0;
const country_code_lookup_1 = require("country-code-lookup");
exports.GOOGLE_MAPS_API_KEY = process.env.GOOGLE_MAPS_API_KEY || 'GOOGLE_MAPS_API_KEY_ENV_UNSET_ERROR';
const getCoordinates = (payload) => ({
    lng: payload.results && payload.results.length ? payload.results[0].geometry.location.lng : 0,
    lat: payload.results && payload.results.length ? payload.results[0].geometry.location.lat : 0
});
const googleApiFactory = (http) => ({
    getCoordinatesByAddress(address) {
        // Stringfy address details from property atributes
        const countryDetails = country_code_lookup_1.countries.find((c) => c.iso2 === address.country_code);
        const countryName = (countryDetails ? countryDetails.country : '');
        const concatAddress = `${address.address1}+${address.address2}+${address.city}+${address.postcode}+${countryName}`;
        return http.get(`json?address=${concatAddress}&key=${exports.GOOGLE_MAPS_API_KEY}`).then((data) => getCoordinates(data));
    }
});
exports.default = googleApiFactory;
//# sourceMappingURL=googlemapsapi.js.map